<template src="./template.html"></template>
<style src="./styles.scss" lang="scss"></style>

<script>
 import { mapActions, mapState } from 'vuex'
 import { isEmpty } from 'lodash'

 export default {
   name: 'LanguageChanger',
   computed: {
     ...mapState('auth', ['settings']),
     ...mapState('translations', { availableLanguages: 'languages' }),
     getLanguageKey() {
       return this.$i18n.locale.replace(/-/g, '_')
     },
   },
   created() {
     if (isEmpty(this.availableLanguages)) {
       this.getAvailableLanguages()
     }
   },
   methods: {
     ...mapActions('translations', ['getAvailableLanguages']),
     changeLocale(key) {
       if (this.getLanguageKey === key) return
       this.$router.push('/' + key)
     },
   },
 }
</script>
